import { labelOfRole, labelOfDepartment } from "./labelOf";
import { Select, Tag } from "antd";
import { isEmpty } from "lodash";
import ColoredBulletLink from "../components/shared/ColoredBulletLink";
import { sortOptions } from "./sorters";

const { Option, OptGroup } = Select;

//renders the titles of home record tables
export const renderRecordTitles = () => {
  return (
    <>
      {" "}
      <div className="flexContainer" style={{ paddingLeft: "0.313rem" }}>
        <div
          className="columns"
          style={{
            textAlign: "left",
            width: "14.875rem"
          }}
        >
          Compliance Obligation
        </div>
        <div
          className="columns"
          style={{
            textAlign: "left",
            width: "7.5rem"
          }}
        >
          Category
        </div>
        <div
          className="columns"
          style={{
            textAlign: "left",
            width: "10rem"
          }}
        >
          <span>Compliance Assessment</span>
        </div>
        <div
          className="columns"
          style={{
            textAlign: "left",
            width: "8.438rem"
          }}
        >
          <span style={{ paddingLeft: "1.313rem" }}>Due Date</span>
        </div>
        <div
          className="columns"
          style={{ textAlign: "left", width: "13.063rem" }}
        >
          Owner
        </div>
      </div>
    </>
  );
};

//helping function for renderOptions. filters the options based on an input (query)
const filterOptionsV2 = (query, currentUsersData) => {
  if (!query) return [];
  const filteredData = getUserOptions(currentUsersData)?.filter(item => {
    const searchableFields = [
      item.name,
      item.email,
      item.role,
      item.department
    ];
    return searchableFields?.some(field =>
      field.toLowerCase().includes(query.toLowerCase())
    );
  });
  return filteredData;
};

//helping function for renderOptions. renderes the label appropriately based on label type
const renderLabel = (user, labelType = "simple") => {
  switch (labelType) {
    case "name":
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            paddingLeft: "1rem"
          }}
        >
          <span className="select-owner-label-title">{`${user?.name}`}</span>
        </div>
      );
    case "email":
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            paddingLeft: "1rem"
          }}
        >
          <span className="select-owner-label-title">{`${user?.name}`}</span>
          <span className="select-owner-label-subtitle">{user?.email}</span>
        </div>
      );
    case "role":
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            paddingLeft: "1rem"
          }}
        >
          <span className="select-owner-label-title">{`${user?.name}`}</span>
          <span className="select-owner-label-subtitle">{user?.role}</span>
        </div>
      );
    case "department":
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            paddingLeft: "1rem"
          }}
        >
          <span className="select-owner-label-title">{`${user?.name}`}</span>
          <span className="select-owner-label-subtitle">
            {user?.department || "No Department"}
          </span>
        </div>
      );
    default:
      return (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <span className="select-owner-label-title">{`${user?.name}`}</span>
        </div>
      );
  }
};

//helping function for renderOptions. creates the structure of each user option
export const getUserOptions = (users, labelType = "simple") => {
  return users?.map(d => ({
    value: d._id,
    key: d._id + "_" + labelType,
    label: `${d?.firstName} ${d?.lastName}`,
    name: `${d?.firstName} ${d?.lastName}`,
    email: d?.email,
    role: labelOfRole(d?.role),
    department: labelOfDepartment(d?.department) || "No Department"
  }));
};

//helping function for renderOptions. groups the results by type
const renderGroupedOptions = (searchValue, filteredData) => {
  // const filteredData = filterOptionsV2();
  const groupedOptions = {};
  filteredData.forEach(item => {
    for (const key in item) {
      const field = item?.[key];
      if (
        key !== "value" &&
        key !== "key" &&
        key !== "label" &&
        key !== "type" &&
        field.toLowerCase().includes(searchValue.toLowerCase())
      ) {
        if (!groupedOptions[key]) {
          groupedOptions[key] = [];
        }
        groupedOptions[key].push(item);
      }
    }
  });
  const groups = Object.entries(groupedOptions);
  return groups.map(([groupName, options]) => (
    <OptGroup key={groupName} label={"Results by " + groupName}>
      {options.map(option => (
        <Option key={option.value + "_" + groupName} value={option.value}>
          {renderLabel(option, groupName)}
        </Option>
      ))}
    </OptGroup>
  ));
};

export const renderOptions = (searchValue = "", currentUsersData = []) => {
  const filteredData = filterOptionsV2(searchValue, currentUsersData);
  if (!searchValue) {
    const data = currentUsersData ? getUserOptions(currentUsersData) : [];
    return !isEmpty(data) ? (
      data.map(item => (
        <Option key={item.value} value={item.value}>
          {item.label}
        </Option>
      ))
    ) : (
      <></>
    );
  } else if (filteredData.length === 0) {
    return <></>;
  } else {
    return <>{renderGroupedOptions(searchValue, filteredData)}</>;
  }
};

export const renderIdOptions = (searchValue = "", mains, extras) => {
  let data = [];
  let base = [];
  if (searchValue.length > 3) {
    if (Number(searchValue[0]) < 7) {
      base = mains;
    } else {
      base = extras;
    }
    data =
      base
        ?.filter(o => o?.code?.startsWith(searchValue))
        ?.map(o => {
          return { value: o?.code, label: o?.code };
        }) ?? [];
  }
  if (data) {
    data = sortOptions(data);
  }
  return !isEmpty(data) ? (
    data.map(item => (
      <Option key={item.value} value={item.value}>
        {item.label}
      </Option>
    ))
  ) : (
    <></>
  );
};

export const renderUserTags = (
  users,
  userData,
  colorA,
  colorB,
  allowClear = false,
  tooltip = "Remove",
  remove = () => {}
) => {
  if (users?.length && userData?.length) {
    return userData.map(user => {
      if (users.includes(user._id))
        return (
          <div className={"owner-tag-home"} style={{ marginTop: "0.5rem" }}>
            <ColoredBulletLink
              text={`${user?.firstName || ""} ${user?.lastName || ""}`}
              unassign={() => remove(user._id)}
              allowClear={allowClear}
              tooltipText={tooltip}
              tagColor={colorA}
              textColor={colorB}
            />
          </div>
        );
    });
  }
};

export const renderGeneralTags = (
  dataset,
  allData,
  fieldToCompare = "_id",
  fieldToShow = "_id",
  colorA,
  colorB,
  allowClear = false,
  tooltip = "Remove",
  remove = () => {}
) => {
  if (dataset?.length && allData?.length) {
    return allData.map(item => {
      if (dataset.includes(item?.[fieldToCompare]))
        return (
          <div className={"owner-tag-home"} style={{ marginTop: "0.5rem" }}>
            <ColoredBulletLink
              text={`${item?.[fieldToShow] || ""}`}
              unassign={() => remove(item?.[fieldToCompare])}
              allowClear={allowClear}
              tooltipText={tooltip}
              tagColor={colorA}
              textColor={colorB}
            />
          </div>
        );
    });
  }
};

export const setMetaCsrf = token => {
  // Find the existing meta tag
  const existingMetaTag = document.querySelector('meta[name="csrf-tkn"]');

  if (existingMetaTag) {
    existingMetaTag.setAttribute("content", token);
  } else {
    const metaTag = document.createElement("meta");
    metaTag.setAttribute("name", "csrf-tkn");
    metaTag.setAttribute("content", token);
    document.head.appendChild(metaTag);
  }
};

export const tagRenderAssessment = props => {
  const { label, value, closable, onClose } = props;
  const tagColors = {
    Pending: { colorBack: "#F4F4F4", colorFont: "#4F4F4F" },
    Partially: { colorBack: "#FDF9F2", colorFont: "#F3A156" },
    Compliant: { colorBack: "#ECFDF3", colorFont: "#027A48" },
    "Non-Compliant": { colorBack: "#FDF2F2", colorFont: "#EB5A5A" },
    na: { colorBack: "#F4F4F4", colorFont: "#4F4F4F" }
  };
  const onPreventMouseDown = event => {
    event.preventDefault();
    event.stopPropagation();
  };
  return (
    <Tag
      color={tagColors?.[value]?.colorBack}
      onMouseDown={onPreventMouseDown}
      closable={closable}
      onClose={onClose}
      className="filter-assessment-tag"
      style={{
        marginInlineEnd: 4,
        fontWeight: 500,
        fontFamily: "Roboto",
        fontSize: "0.75rem",
        color: tagColors?.[value]?.colorFont,
        borderRadius: "1rem",
        "& .ant-tag-close-icon": {
          color: tagColors?.[value]?.colorFont
        }
      }}
    >
      {label}
    </Tag>
  );
};

export const getMetaCsrf = () => {
  return document
    .querySelector("meta[name='csrf-tkn']")
    ?.getAttribute("content");
};
